/**
 * Created by ostapenko.r on 9/26/2014.
 */
angular.module('flipto.components.fieldEditors',
    [
        'textAngular',
        'flipto.components.common',
        'flipto.components.textAngularTools'
    ]);